import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { AgentService } from '../../services';
import { Agent } from '../../models';

export interface AgentSelectionResult {
  selectedAgent: Agent | null;
}

@Component({
  selector: 'selfai-platform-agent-selection-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, Button],
  templateUrl: './agent-selection-dialog.component.html',
  styleUrls: ['./agent-selection-dialog.component.scss']
})
export class AgentSelectionDialogComponent implements OnInit {
  public availableAgents$: Observable<Agent[]>;
  public selectedAgent: Agent | null = null;

  constructor(
    private ref: DynamicDialogRef,
    private agentService: AgentService,
  ) {
    this.availableAgents$ = this.agentService.availableAgents$;
  }

  public ngOnInit(): void {
    this.availableAgents$.subscribe(agents => {
      const availableAgents = agents.filter(agent => agent.isAvailable);
      if (availableAgents.length === 1) {
        this.selectedAgent = availableAgents[0];
      }
    });
  }

  public selectAgent(agent: Agent): void {
    if (agent.isAvailable) {
      this.selectedAgent = agent;
    }
  }

  public confirm(): void {
    if (this.selectedAgent) {
      const result: AgentSelectionResult = {
        selectedAgent: this.selectedAgent
      };
      this.ref.close(result);
    }
  }

  public cancel(): void {
    this.ref.close(null);
  }

  public getAgentIcon(agent: Agent): string {
    switch (agent.category) {
      case 'pipeline':
        return 'pi pi-cog';
      case 'common':
        return 'pi pi-database';
      default:
        return 'pi pi-robot';
    }
  }
}
